var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.panel ? 'synergyPanel' : 'synergyPopup',{tag:"component",attrs:{"synergy":_vm.synergy}})}
var staticRenderFns = []

export { render, staticRenderFns }